import { z } from "zod";
const uuidFilter = z.string().uuid().optional();
export const analyticsFilterSchema = z.object({
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    hotelId: uuidFilter,
    locationId: uuidFilter,
    subLocationId: uuidFilter,
    qrRouteId: uuidFilter,
    unitCode: z.string().max(80).optional(),
    language: z.string().max(20).optional(),
    mealPeriod: z.string().max(40).optional(),
    staffShiftId: uuidFilter,
    questionCategory: z.string().max(120).optional(),
    deviceType: z.string().max(40).optional(),
    requestPath: z.string().max(200).optional()
});
